<template>
  <section class="app-main">
    <router-view style="margin-top: 105px;"/>
    <div v-if="showQRCode" class="body-left">
      <img class="title-img" src="@/assets/image/beefapp_code.png" width="160px" height="223px" />
      <div class="code-cancel" @click="handleClickCancel()"></div>
    </div>
    <div v-if="showFCService" class="body-left2">
      <img src="@/assets/image/beeffcservice.png" alt="title-img" width="208px" height="362px" />
      <div class="code-cancelFCService" @click="handleClickCancelFCService()"></div>
    </div>
    <div v-if="showFCTeam" class="body-left1">
      <div class="team-img" alt="title-img"></div>
      <div class="code-cancelFCTeam" @click="handleClickCancelFCTeam()"></div>
    </div>
    <!--
    <div v-if="showFCTeamFull" class="body-left3">
      <img src="@/assets/image/beeffcteamfull.png" alt="title-img" width="198px" height="506px" @click="handleClickCancelFCTeamFull()"/>
    </div>
    -->
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  props: {
    isShowQRCode: {
      type: Boolean,
      default: true
    },
    isShowFCService: {
      type: Boolean,
      default: true
    },
    isShowFCTeam: {
      type: Boolean,
      default: true
    },
    isShowFCTeamFull: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showQRCode: true,
      showFCService: true,
      showFCTeam: true,
      showFCTeamFull: false
    }
  },
  watch: {
    isShowQRCode (newVal) {
      this.showQRCode = newVal
    },
    isShowFCService (newVal) {
      this.showFCService = newVal
    },
    isShowFCTeam (newVal) {
      this.showFCTeam = newVal
    },
    isShowFCTeamFull (newVal) {
      this.showFCTeamFull = newVal
    }
  },
  methods: {
    handleClickCancel () {
      this.$emit('tab-cancel', false)
    },
    handleClickCancelFCService () {
      this.$emit('tab-cancel-fc-service', false)
    },
    handleClickCancelFCTeam () {
      this.$emit('tab-cancel-fc-team', false)
    },
    handleClickCancelFCTeamFull () {
      this.$emit('tab-cancel-fc-team-full', false)
    }
  }
}
</script>

<style scoped>
.app-main {
  /* min-height: calc(100vh - 492px); */
  overflow: hidden;
}
.body-left{
    color: #717375;
    display: block !important;
    position: fixed;
    text-align: center;
    top: 190px;
    z-index: 999;
    float: right;
    right: 5px;
}

.body-left1{
    color: #717375;
    display: block !important;
    position: fixed;
    text-align: center;
    top: 190px;
    z-index: 999;
    float: left;
    left: 5px;
}

.body-left2{
    color: #717375;
    display: block !important;
    position: fixed;
    text-align: center;
    top: 550px;
    z-index: 999;
    float: left;
    left: 5px;
}

.body-left3{
  color: #717375;
  display: block !important;
  position: fixed;
  text-align: center;
  top: 280px;
  z-index: 999;
  float: left;
  left: 5px;
}

.bodyvisual-left{
  color: #717375;
  display: block !important;
  position: fixed;
  text-align: center;
  top: 510px;
  z-index: 999;
  float: right;
  right: 5px;
}

.code-cancel{
  position: fixed;
  width: 27px;
  height: 27px;
  top:190px;
  /* left: 135px; */
  right: 7px;
  cursor: pointer;
  /*border: 3px solid #717375;*/
}

.code-cancel1{
  position: fixed;
  width: 23px;
  height: 23px;
  top:510px;
  /* left: 135px; */
  right: 5px;
  cursor: pointer;

}

.code-cancelFCTeam{
  position: fixed;
  width: 27px;
  height: 27px;
  top:190px;
  /* left: 135px; */
  left: 176px;
  cursor: pointer;
  /*border: 3px solid #717375;*/
}

.code-cancelFCService{
  position: fixed;
  width: 27px;
  height: 27px;
  top:550px;
  /* left: 135px; */
  left: 176px;
  cursor: pointer;
  /*border: 3px solid #717375;*/
}

.title-img{
  width: 160px;
}

.team-img {
  cursor: pointer;
  background-image: url('../../../../assets/image/beeffcteam.png');
  background-size: 208px 362px;
  background-repeat: no-repeat;
  width: 208px;
  height: 362px;
}

.team-img:hover {
  border: 1px solid #717375;
  width: 290px;
  height: 715px;
  top: 190px;
  z-index: 1999;
  float: left;
  left: 5px;
  background-image: url('../../../../assets/image/beeffcteamfull.png');
  background-size: 290px 715px;
  background-repeat: no-repeat;
}
</style>
